import React from "react";
import { initError } from "../configs/error-config";
import { ErrorType } from "../models/common/error";
import PopupCustom from "../components/Popup";
import { imageList } from "../configs/images-config";
import Dialog from "../components/dialog/Dialog";
import { updateState } from "../utils/function-utils";
import { useInitialCofig } from "../hooks/initialConfig-hook";

type ErrorTypeContext = {
    errors: ErrorType,
    setError: React.Dispatch<React.SetStateAction<ErrorType>>;
}

const ErrorContext = React.createContext<ErrorTypeContext>({
    errors: initError,
    setError: () => null,
});

export const ErrorContextProvider = ({ children }: {children: React.ReactNode}) => {
    const [errorState, setErrorState] = React.useState<ErrorType>(initError);
    const {initialConfig} = useInitialCofig();

    return (
        <ErrorContext.Provider value={{errors: errorState, setError: setErrorState}} >
            {children}
            {errorState && (
                <React.Fragment>
                    {errorState.errorRegister.status && (
                        <PopupCustom type='error' image={imageList.failed_image}>
                            <p>{errorState.errorRegister.message}</p>
                        </PopupCustom>
                    )}
                    {errorState.errorConnection.status && (
                        <PopupCustom type='error' image={imageList.failed_image}>
                            <p>{errorState.errorConnection.message}</p>
                        </PopupCustom>
                    )}
                    {errorState.errorParams.status && (
                        <PopupCustom type='error' image={imageList.failed_image}>
                            <p>{errorState.errorParams.message}</p>
                        </PopupCustom>
                    )}
                    {errorState.errorOTP.status && (
                        <PopupCustom type='error' image={imageList.failed_image}>
                            <p>{errorState.errorOTP.message}</p>
                        </PopupCustom>
                    )}
                    <Dialog.Error show={errorState.errorDialogOTP.status} handleClose={() => 
                        updateState<ErrorType>({errorDialogOTP: {status: false, message: ""}}, setErrorState)}
                        dialogBodyStyles={initialConfig.styles.error_message_box_style}
                    >
                        {errorState.errorDialogOTP.message}
                    </Dialog.Error>
                </React.Fragment>
            )}
        </ErrorContext.Provider>
    )
}

export const useErrors = () => React.useContext(ErrorContext);